import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export const CGV = () => {
  const { language } = useLanguage();

  return (
    <div className="min-h-screen pt-24 pb-16 bg-slate-50" data-testid="cgv-page">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="font-heading font-bold text-3xl md:text-4xl text-slate-900 mb-8">
          {language === 'fr' ? 'Conditions Générales de Vente' : 'Terms and Conditions'}
        </h1>

        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8">
          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 1 - Objet
            </h2>
            <p className="text-slate-600">
              Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles 
              entre Tannou (SASU en cours de constitution) et ses clients pour la fourniture de services d'intelligence
              artificielle et de création de sites web. Toute commande implique l'acceptation sans réserve 
              des présentes CGV.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 2 - Services proposés
            </h2>
            <p className="text-slate-600 mb-4">TANNOU propose les services suivants :</p>
            <ul className="list-disc pl-6 text-slate-600 space-y-2">
              <li><strong>Agents IA pour la Formation :</strong> Solutions d'automatisation pour les organismes de formation</li>
              <li><strong>Agents IA pour les PME :</strong> Outils d'intelligence artificielle pour les petites et moyennes entreprises</li>
              <li><strong>Agents IA pour Freelances :</strong> Assistants virtuels pour les travailleurs indépendants</li>
              <li><strong>Agents IA pour Employés de bureau :</strong> Automatisation des tâches administratives</li>
              <li><strong>Création de sites web sur mesure :</strong> Design, développement et hébergement de sites web professionnels</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 3 - Tarifs
            </h2>
            <p className="text-slate-600 mb-4">
              Les prix sont indiqués en euros hors taxes (HT). La TVA applicable sera ajoutée au taux en 
              vigueur. Les tarifs peuvent être modifiés à tout moment, mais les services seront facturés 
              sur la base des tarifs en vigueur au moment de la commande.
            </p>
            <div className="bg-slate-50 p-4 rounded-lg text-slate-600">
              <p className="font-semibold mb-2">Offres Site Web :</p>
              <ul className="space-y-1">
                <li>• Pack Starter : 990€ HT</li>
                <li>• Pack Business : 2 490€ HT</li>
                <li>• Pack E-Commerce : 4 990€ HT</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 4 - Commande
            </h2>
            <p className="text-slate-600">
              La commande est validée après réception du paiement intégral ou de l'acompte convenu. 
              Un devis détaillé sera établi préalablement à toute commande. L'acceptation du devis par 
              le client vaut commande ferme et définitive. Le client dispose d'un délai de rétractation 
              de 14 jours à compter de la signature du contrat, conformément à l'article L.221-18 du 
              Code de la consommation (pour les clients particuliers).
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 5 - Modalités de paiement
            </h2>
            <div className="text-slate-600 space-y-3">
              <p>Le paiement peut être effectué par :</p>
              <ul className="list-disc pl-6 space-y-1">
                <li>Carte bancaire (via Stripe)</li>
                <li>Virement bancaire</li>
                <li>PayPal</li>
              </ul>
              <p className="mt-4">
                <strong>Coordonnées bancaires pour virement :</strong>
              </p>
              <div className="bg-slate-50 p-4 rounded-lg mt-2">
                <p>Titulaire : Katrina Laurent</p>
                <p>IBAN : BE86 9674 2244 3450</p>
                <p>BIC/SWIFT : TRWIBEB1XXX</p>
                <p>Banque : Wise, Rue du Trône 100, Brussels, Belgium</p>
              </div>
              <p className="mt-4">
                Sauf accord particulier, les factures sont payables à 30 jours. Tout retard de paiement 
                entraînera des pénalités de retard au taux de 3 fois le taux d'intérêt légal, ainsi qu'une 
                indemnité forfaitaire de 40€ pour frais de recouvrement.
              </p>
            </div>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 6 - Délais de livraison
            </h2>
            <p className="text-slate-600">
              Les délais de livraison sont donnés à titre indicatif. Pour la création de sites web, 
              les délais moyens sont :
            </p>
            <ul className="list-disc pl-6 text-slate-600 mt-2 space-y-1">
              <li>Pack Starter : 2 à 4 semaines</li>
              <li>Pack Business : 4 à 8 semaines</li>
              <li>Pack E-Commerce : 8 à 12 semaines</li>
            </ul>
            <p className="text-slate-600 mt-4">
              Ces délais peuvent varier en fonction de la complexité du projet et de la réactivité 
              du client dans la fourniture des contenus et validations.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 7 - Propriété intellectuelle
            </h2>
            <p className="text-slate-600">
              Après paiement intégral, le client devient propriétaire du site web développé pour son compte. 
              Toutefois, TANNOU conserve la propriété intellectuelle sur les outils, méthodes et composants 
              génériques développés ou utilisés pour la réalisation du projet. Les éléments spécifiquement 
              créés pour le client (design, contenus personnalisés) lui sont cédés.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 8 - Garanties
            </h2>
            <p className="text-slate-600">
              TANNOU garantit le bon fonctionnement des prestations pendant une période de 12 mois à compter 
              de la livraison. Cette garantie couvre les corrections de bugs et dysfonctionnements, à l'exclusion 
              des modifications demandées par le client ou des problèmes liés à l'hébergement, aux services tiers 
              ou à une mauvaise utilisation.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 9 - Responsabilité
            </h2>
            <p className="text-slate-600">
              La responsabilité de TANNOU est limitée au montant des prestations effectivement payées par le client. 
              TANNOU ne pourra être tenu responsable des dommages indirects, pertes d'exploitation, de données ou de 
              chiffre d'affaires. Le client est responsable des contenus qu'il fournit et garantit TANNOU contre 
              toute réclamation de tiers.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 10 - Résiliation
            </h2>
            <p className="text-slate-600">
              En cas de manquement grave de l'une des parties à ses obligations, l'autre partie pourra résilier 
              le contrat par lettre recommandée avec accusé de réception, après mise en demeure restée infructueuse 
              pendant 15 jours. En cas de résiliation anticipée par le client, les sommes déjà versées resteront 
              acquises à TANNOU à titre d'indemnité.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 11 - Confidentialité
            </h2>
            <p className="text-slate-600">
              Les parties s'engagent à garder confidentielles toutes les informations échangées dans le cadre 
              de leur collaboration. Cette obligation de confidentialité perdurera pendant une durée de 2 ans 
              après la fin du contrat.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 12 - Droit applicable et juridiction
            </h2>
            <p className="text-slate-600">
              Les présentes CGV sont soumises au droit français. En cas de litige, les parties s'efforceront 
              de trouver une solution amiable. À défaut, les tribunaux de Paris seront seuls compétents.
            </p>
          </section>

          <section>
            <h2 className="font-heading font-semibold text-xl text-slate-900 mb-4">
              Article 13 - Médiation
            </h2>
            <p className="text-slate-600">
              Conformément aux articles L.616-1 et R.616-1 du Code de la consommation, tout consommateur a le droit 
              de recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable du litige. 
              Les coordonnées du médiateur seront communiquées sur demande.
            </p>
          </section>

          <p className="text-slate-400 text-sm pt-4 border-t">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
          </p>
        </div>
      </div>
    </div>
  );
};
